import React from 'react';
import styles from '../Operations.module.css';

interface ARW1Component extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * TOTALCUSTCOUNT - Total Customer Count
 * KPI information component
 */
const ARW1: ARW1Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Total Customer Count measures all customers enrolled in the Ace Rewards program.<br/><br/>
        This will not include any canceled Ace Rewards members or accounts flagged as a California Consumer Privacy Act  opt-out.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Consistently ask all customers at POS if they are a member of the Ace Rewards program. <br /><br />
        If not, encourage customers to enroll at POS or through the Ace Hardware mobile app.<br/><br />
        Invest in in-store signage to highlight the benefits of the Ace Rewards program.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        <ul>
          <li>Reinforce the importance of the Ace Rewards program with all cashiers, ensuring they understand both the benefits and the core components of the program.</li>
          <li>Provide training opportunities for all employees to deepen their knowledge and confidence in promoting Ace Rewards.</li>
          <li>
            Encourage associates to review the video resources available on Ace Learning Place:
            <ul style={{ listStyleType: 'circle' }}>
              <li>Ace Rewards Cashier Quick Tips</li>
              <li>Ace Rewards Program Overview</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};


ARW1.title = 'Total Customer Count - Ace Rewards';
ARW1.actionTitle = 'total customer drilldown';
ARW1.actionHyperlink = 'dynamicURL:WFC:current';
export default ARW1;

